export enum DateFormat {
  Local = 'dd/MM/yyyy',
  LocalDateTime = 'dd/MM/yyyy HH:mm',
  LocalTime = 'HH:mm',
}
